import CreateSiHaDocumentationRequestModelBase from '../_generated/modelBases/create-si-ha-documentation-request-model-base';

export default class CreateSiHaDocumentationRequestModel extends CreateSiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
